import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import butterflyLogo from '../../assets/logo_1.png';
import bgImage from '../../assets/bgimg3.png';

const ImpactSection = () => {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  
  return (
    <section className="relative bg-[#005CA8] text-white overflow-hidden" data-aos="zoom-in">

      {/* Background Image with 50% Transparency */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-8 sm:py-10 md:py-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

        {/* Text Content */}
        <div className="text-center md:text-left">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            BEYOND BUSINESS,<br />INTO IMPACT
          </h1>
          <p className="text-base sm:text-lg md:text-lg leading-relaxed mb-4 sm:mb-6 text-white/90">
            Butterfly Impact is more than a group of businesses — it's a vibrant ecosystem built to inspire transformation in every part of life and work. 
            From shaping careers and developing resilient spaces to building strong households and supporting mental wellness, 
            our goal is to do what’s necessary to build a fulfilled life using impact — with heart, curiosity, and purpose at the root.
          </p>
          <a
              href="https://wa.me/919952753900"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-white text-[#005CA8] font-semibold rounded hover:opacity-90 transition inline-block text-center"
            >
            Join With Us
          </a>
        </div>

        {/* Right: Butterfly Image */}
        <div className="flex justify-center md:justify-end mt-6 md:mt-0">
          <img
            src={butterflyLogo}
            alt="Butterfly Logo"
            className="w-52 sm:w-72 md:w-96" // increased sizes
          />
        </div>

      </div>
    </section>
  );
};

export default ImpactSection;
